module.exports = __webpack_public_path__ + "img/step_1.608b66e5.png";